const ACTION_TYPES = {
    UPDATE_RECOMMENDATIONS: 'UPDATE_RECOMMENDATIONS',
    UPDATE_REQUEST_PARAMS: 'UPDATE_REQUEST_PARAMS'
};

const initialState = {
    constructorRecommendations: {},
    constructorRequestParams: {}
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_RECOMMENDATIONS: {
            const data = action.payload;
            const { podId, constructorTitle, constructorRecommendations } = data;

            return Object.assign({}, state, {
                constructorRecommendations: { ...state.constructorRecommendations, [podId]: { constructorTitle, constructorRecommendations } }
            });
        }
        case ACTION_TYPES.UPDATE_REQUEST_PARAMS: {
            const params = action.payload;

            return Object.assign({}, state, {
                constructorRequestParams: params
            });
        }
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
